import React from "react";
import { WidgetDetails, Title, BlogImg } from "../../assets/styled/BlogStyle";

const Blog_2 = () => {
  return (
    <>
      <BlogImg
        src="https://res.cloudinary.com/dmbpo49ak/image/upload/v1677758302/RAKtherm/FOR-WERBSITE_tnp6ty.jpg"
        alt="blog-1"
      />
      <Title>The Future of Drainage Piping Systems Delivered Today</Title>
      <WidgetDetails>
        With RAKtherm’s Multilayer Drainage Piping Solutions, we have thoroughly
        understood piping systems to distribute waste water efficiently. Our
        in-depth research and development have allowed us to develop a
        contemporary approach to analyzing piping networks over the past 60
        years.
      </WidgetDetails>

      <WidgetDetails>
        Since we are the leading innovator and provider of piping solutions in
        the industry, we are dedicated to providing high-quality solutions’
        range and services.
      </WidgetDetails>

      <Title>Why RAKtherm DWV system?</Title>
      <WidgetDetails>
        One of RAKtherm's most recent innovations is the DWV System (Drainage,
        Waste, and Vent). Compared to conventional pipes, this modern,
        three-layer pipe is more durable, composed of new-generation premium
        materials, and has solid walls.
      </WidgetDetails>

      <Title>The Ground-Breaking RNP technology from RAKtherm</Title>
      <WidgetDetails>
        A consistent middle layer structure, with individual cells, ensures
        increased mechanical properties. In contrast, an inner and outer layer
        are integrated to create a "sandwich construction" that surpasses noise
        reduction, durability, flexibility, and longevity requirements.
      </WidgetDetails>

      <Title>RAKtherm's noise-reduction technology</Title>
      <WidgetDetails>
        The newest line of PVC-U piping systems from RAKtherm has their
        Noise-Reduction Technology. One of the most important features of a
        building's interior design is noise control.Our expertise in pipe
        engineering can help to fulfill the growing demand for customers'
        criteria
      </WidgetDetails>

      <WidgetDetails>
        connected to well-being as building technology gets more intricate and
        technically demanding. The pipes are constructed using multiple layers
        of PVC-U for Sound Attenuation System applications that are intended to
        reduce environmental noise. RAKtherm satisfies the German standard DIN
        4109 and EN 14366, demonstrating its excellent efficacy in sewage system
        noise reduction.
      </WidgetDetails>

      <Title>RAKtherm's Triple-Sealing-Lip concept</Title>
      <WidgetDetails>
        RAKtherm's Triple-Sealing-Lip solutions are perfectly engineered for PVC
        sewer pipe systems. An integrated seal for plastic pipe systems for
        above- and below-ground drainage and sewage systems is provided by the
        multi-layer reinforced rubber junction.
      </WidgetDetails>
      <WidgetDetails>
        The triple-sealing-lip solutions from RAKtherm now outperform the
        competition because they provide a secure seal throughout a wide range
        of pipe-joint level tolerances while requiring less jointing force. The
        pipe maker places a DIN lockTM, a combined lip and compression seal, in
        the socket. Any allowable fluctuation in the groove will be absorbed by
        the seal.
      </WidgetDetails>

      <Title>Geometric Design for Functionality (GDFF)</Title>
      <WidgetDetails>
        The innovative design retains the seal securely in the proper position
        throughout pipe transportation and joint assembly thanks to a flexible
        thermoplastic elastomeric sealing element that is linked to a
        polypropylene retaining ring.
      </WidgetDetails>
      <WidgetDetails>
        The RAKtherm Triple-Sealing-Sip seal is engineered to have a low
        assembly force at both the minimum and maximum gap, allowing for good
        compression on each of its three lips. Maximum compression can be used
        during assembly without encountering any issues.
      </WidgetDetails>

      <WidgetDetails>
        Do you want to go with our innovative piping systems for your next
        drainage project? Contact our Project Sales Representative to discuss
        your project needs.
      </WidgetDetails>
    </>
  );
};

export default Blog_2;
